{
  "certificates": {
    "navigation_title": "Certificados",
    "create_new": "Crear Certificado",
    "devices": "Dispositivos",
    "title": "Certificados",
    "new": "Crear Certificado",
    "edit": "Editar Certificado",
    "common": "Información del lugar",
    "name": "Nombre",
    "description": "Descripción",
    "phone": "Teléfono",
    "address": "Dirección",
    "place_picture": "Imagen del lugar",
    "dialogs": {
      "delete": {
        "title": "¿Está seguro?",
        "content": "¿Está seguro de que desea eliminar el certificado '%{name}'? No puede deshacer esta acción"
      }
    }
  }
}
